<template>
  <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false"
  :md-close-on-esc="false">
    <md-card>
      <md-card-header>
        <div class="md-title">Subir archivo</div>
      </md-card-header>
      <md-card-content>
        <md-field>
          <label>Selecciona el archivo</label>
          <md-file accept=".pdf" @md-change="viewFile"/>
        </md-field>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-success" @click="uploadFilePDf" :disabled="disabledUpload">Subir</md-button>
        <md-button @click="closeModal">Cancelar</md-button>
      </md-card-actions>
    </md-card>
  </md-dialog>
</template>
<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    ObjQuotation: {
      type:Object,
      default: () => {}
    }
  },
  data () {
    return {
      filePDF: null
    }
  },
  methods: {
    closeModal () {
      this.filePDF = null
      this.$emit('closeDialog')
    },
    uploadFilePDf () {
      this.$emit('uploadFilePDf', this.filePDF, this.ObjQuotation)
      this.closeModal()
    },
    viewFile (files) {
      this.filePDF = files[0]
    }
  },
  computed: {
    disabledUpload () {
      if (this.filePDF) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
  .md-card {
    width: 500px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Purchases/QuotesTracking/uploadFileModal.vue